import React from 'react';

const NotFound = () => (
    <>
        <h3>404 Not Found!!</h3>
    </>
)

export default NotFound;